var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video-pop-up'),_c('drawer',{attrs:{"sidebar":_vm.sidebar},on:{"toggleSidebar":_vm.toggleSidebar}}),_c('header-three',{on:{"toggleSidebar":_vm.toggleSidebar}}),_c('trending-post',{staticClass:"pt-65",attrs:{"datas":_vm.trendingPost || [],"buisnessData":_vm.buisnessData || []}}),_c('Footer'),_c('back-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }